import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credentials|Edit History|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsCredentialEditHistory';
export type SPCatalogsCredentialEditHistoryLocNames =
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitlePage`;

export const spCatalogsCredentialEditHistoryLocs: LocDefs<SPCatalogsCredentialEditHistoryLocNames> =
	{
		SPCatalogsCredentialEditHistoryTitleSection: {
			defaultValue: 'No history',
			description: 'Text shown when there is no history to display',
			displayPath: `${pathStart}No history`,
			displayType: 'Content',
			legacyName: 'Credential/Catalogs.Credentials.EditHistory.Content.NoHistory',
			...sharedProperties,
		},
		SPCatalogsCredentialEditHistoryTitlePage: {
			defaultValue: 'Credential Catalog Edit History',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName: 'Credential/Catalogs.Credentials.EditHistory.Title.PageTitle',
			...sharedProperties,
		},
	};

export type SPCatalogsCredentialEditHistoryLocType =
	LocMap<SPCatalogsCredentialEditHistoryLocNames>;
